// context/LanguageContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageContext = createContext();

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within LanguageProvider');
    }
    return context;
};

export const LanguageProvider = ({ children }) => {
    const { i18n } = useTranslation();
    // Initialiser avec la valeur du localStorage ou 'fr' par défaut
    const [currentLanguage, setCurrentLanguage] = useState(() => {
        const savedLang = localStorage.getItem('preferred-language');
        return savedLang || 'fr';
    });

    // Synchroniser i18n avec la langue courante au chargement
    useEffect(() => {
        if (i18n.language !== currentLanguage) {
            i18n.changeLanguage(currentLanguage);
        }
    }, [currentLanguage, i18n]);

    // Écouter les changements de i18n (cas où i18n changerait ailleurs)
    useEffect(() => {
        const handleLanguageChanged = (lng) => {
            if (lng !== currentLanguage) {
                setCurrentLanguage(lng);
                localStorage.setItem('preferred-language', lng);
            }
        };

        i18n.on('languageChanged', handleLanguageChanged);

        return () => {
            i18n.off('languageChanged', handleLanguageChanged);
        };
    }, [i18n, currentLanguage]);

    const changeLanguage = (lang) => {
        // Mettre à jour i18n d'abord
        i18n.changeLanguage(lang);
        // Le state sera mis à jour par l'événement languageChanged
    };

    return (
        <LanguageContext.Provider value={{ currentLanguage, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};